export enum DropDownPosition {
  TOP = 'POSITION_TOP',
  BOTTOM = 'POSITION_BOTTOM'
}

export enum FILE_ACTION {
  ORIGINAL = 'ORIGINAL',
  ERRORS = 'ERRORS'
}

export enum FILE_STATUS {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export type UploadFileResponse = {
  success: boolean;
  message: string;
  error: boolean;
};

export interface ICallLimitHistory {
  referenceId: string;
  ownerId: string;
  requestSubType: string;
  successCount: number;
  failureCount: number;
  startTime: string;
  endTime: string;
  uploadStatus: string;
}

export const REQUEST_SUB_TYPE = 'CALL_COUNT_EXPERIMENT_REQUEST';
